import React from 'react'
import { PROJECT } from 'app-constants'
import { SidebarResourceKind } from 'types'

/**
 * What archiving a document or table does, for its archive confirmation. Shared by the resource's own
 * settings menu and the sidebar's row menu, so both say the same. `plural` words it for several of them.
 */
const ArchiveExplanation: React.FC<{ kind: SidebarResourceKind; plural?: boolean }> = ({ kind, plural = false }) => {
  if (kind === 'document') {
    return (
      <div className="mt-5">
        {plural
          ? 'Once these documents are archived they will be removed from the navigation sidebar. If one of them is used as the '
          : 'Once this document is archived it will be removed from the navigation sidebar. If this document is used as the '}
        {PROJECT} homepage it may disrupt the functionality of your {PROJECT}.
      </div>
    )
  }
  return (
    <div className="mt-5">
      Formula columns and select columns within {plural ? 'the tables' : 'the table'} will be changed to
      <span className="font-semibold ml-[5px] mr-[5px]">Text</span>
      <span>type</span>. All <span className="font-semibold">join columns and formulas will be removed</span>.
      <br />
      <br />
      If {plural ? 'a' : 'the'} table is restored, you will have to configure these columns again.
    </div>
  )
}

export default ArchiveExplanation
